const initialState = {
    arr: []
}

const expArrayReducer = (state = initialState, action) => {
    switch(action.type){
        case 'EXP_ARRAY' : {
            return {
                ...state,
                arr: action.arr
            }
        }
        default: {
            return state
        }
    }
}

export default expArrayReducer